import config from "@/config/global.config"
import Vue from "vue"

function Logger() {
  this._isEnabled = config.loggingEnabled()
}

Logger.prototype.log = function () {
  if (!this.isEnabled()) {
    return false
  }

  console.log(...arguments)

  return true
}

Logger.prototype.isEnabled = function () {
  return console && this._isEnabled
}

Logger.prototype.error = function () {
  if (!this.isEnabled()) {
    return false
  }

  console.error(...arguments)

  return true
}

Logger.prototype.trace = function () {
  if (!this.isEnabled()) {
    return false
  }

  console.trace()
}

Logger.prototype.install = function(vue, options) {
  Vue.prototype.$log = loggerInstance
}

const loggerInstance = new Logger();

export default loggerInstance;
